import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { withErrorBoundary } from "react-error-boundary";
import "@effektify/logger";
import "@effektify/types";
import "react";
import "sprintf-js";
import "@effektify/types/guards";
import "@effektify/cache";
import "@effektify/components";
import useCardSizes from "../../hooks/useCardSizes.js";
import useCardState from "../../hooks/cardProps/useCardState.js";
import "@effektify/data-provider";
import CardError from "../CardError.js";
import { CardRenderer } from "./CardRenderer.js";
const CardWithData = t0 => {
  const $ = c(11);
  const {
    config,
    className: t1,
    loading: t2
  } = t0;
  const className = t1 === void 0 ? "" : t1;
  const loading = t2 === void 0 ? false : t2;
  const {
    getCardDimensions
  } = useCardSizes();
  const {
    data,
    isLoading: isCardLoading,
    shouldRender
  } = useCardState(config);
  if (!shouldRender) {
    return null;
  }
  const t3 = config.variant;
  let t4;
  if ($[0] !== config || $[1] !== getCardDimensions || $[2] !== t3) {
    t4 = getCardDimensions(t3, config);
    $[0] = config;
    $[1] = getCardDimensions;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const dimensions = t4;
  const t5 = loading || isCardLoading;
  const t6 = `card-with-data ${className || ""} ${config.variant || ""}`;
  let t7;
  if ($[4] !== config || $[5] !== data || $[6] !== dimensions.minHeight || $[7] !== dimensions.width || $[8] !== t5 || $[9] !== t6) {
    t7 = /* @__PURE__ */jsx(CardRenderer, {
      data,
      config,
      isLoading: t5,
      height: dimensions.minHeight,
      width: dimensions.width,
      className: t6
    });
    $[4] = config;
    $[5] = data;
    $[6] = dimensions.minHeight;
    $[7] = dimensions.width;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
const SafeCardWithData = withErrorBoundary(CardWithData, {
  FallbackComponent: CardError
});
export { CardWithData, SafeCardWithData, CardWithData as default };